export const SHELL_ORIGIN_KEY="jutro-shell-origin";export const MFE_NAME_KEY="jutro-mfe-name";